"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encryptDecryptEmailQueueObj = exports.encryptDecryptEconsult = exports.encryptDecryptMessages = void 0;
var crypto_1 = require("./crypto");
/**
 * Encrypt or decrypt activity message. Encryption or decryption is done in-place
 * @param messages Message objects from activity/{activityId}/messages
 * @param dbRef Reference to the encryption key in firestore
 * @param options encrypt: Set true to encrypt. decrypt: Set true to decrypt
 * @returns void
 */
function encryptDecryptMessages(messages, dbRef, options) {
    return (0, crypto_1.initializeAndLoadKey)(dbRef, options)
        .then(function (key) {
        messages.forEach(function (msg) {
            msg.message = (0, crypto_1.encryptOrDecrypt)(msg.message, key, options);
        });
    });
}
exports.encryptDecryptMessages = encryptDecryptMessages;
/**
 * Encrypt or decrypt econsult. Encryption or decryption is done in-place
 * @param econsult Econsult object
 * @param dbRef Reference to the encryption key in firestore
 * @param options encrypt: Set true to encrypt. decrypt: Set true to decrypt
 * @returns void
 */
function encryptDecryptEconsult(econsult, dbRef, options) {
    return (0, crypto_1.initializeAndLoadKey)(dbRef, options)
        .then(function (key) {
        var fieldsToEncrypt = ["patientEmail", "patientFirstName", "patientLastName", "patientPhone", "phn", "specialty", "subsite"];
        fieldsToEncrypt.forEach(function (field) {
            var val = econsult[field];
            if (typeof val === "string") {
                assignEconsultField((0, crypto_1.encryptOrDecrypt)(val, key, options), econsult, field);
            }
        });
        if (econsult.symptoms !== undefined) {
            econsult.symptoms = (0, crypto_1.encryptOrDecryptObject)(econsult.symptoms, key, options, true);
        }
        if (econsult.information !== undefined) {
            econsult.information = (0, crypto_1.encryptOrDecryptObject)(econsult.information, key, options, false);
        }
        if (econsult.oopData !== undefined) {
            econsult.oopData = (0, crypto_1.encryptOrDecryptObject)(econsult.oopData, key, options, false);
        }
    });
}
exports.encryptDecryptEconsult = encryptDecryptEconsult;
/**
 * Encrypt or decrypt email queue object. Encryption or decryption is done in-place
 * @param emailQueueObj Email queue object
 * @param dbRef Reference to the encryption key in firestore
 * @param options encrypt: Set true to encrypt. decrypt: Set true to decrypt
 * @returns void
 */
function encryptDecryptEmailQueueObj(emailQueueObj, dbRef, options) {
    return (0, crypto_1.initializeAndLoadKey)(dbRef, options)
        .then(function (key) {
        emailQueueObj.body = (0, crypto_1.encryptOrDecrypt)(emailQueueObj.body, key, options);
        if (emailQueueObj.bodyHtml !== undefined)
            emailQueueObj.bodyHtml = (0, crypto_1.encryptOrDecrypt)(emailQueueObj.bodyHtml, key, options);
        emailQueueObj.subject = (0, crypto_1.encryptOrDecrypt)(emailQueueObj.subject, key, options);
    });
}
exports.encryptDecryptEmailQueueObj = encryptDecryptEmailQueueObj;
function assignEconsultField(value, econsult, field) {
    econsult[field] = value;
}
//# sourceMappingURL=aletheamd-crypto.js.map